import { twMerge } from "tailwind-merge";
import type { ButtonHTMLAttributes, ReactNode } from "react";

type FunctionalButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    visible?: boolean;
    titleClassName?: string;
    icon?: ReactNode;
    hoverTextClassName?: string;
    hoverText?: string;
    reverse?: boolean;
};

const FunctionalButton = ({
    className = "",
    visible = true,
    titleClassName = "",
    title = "",
    icon = undefined,
    hoverTextClassName = "",
    hoverText = "",
    disabled = false,
    reverse = false,
    type = "button",
    onClick,
    children,
    ...rest
}: FunctionalButtonProps) => {
    return visible ? (
            <button
                type={type}
                className={twMerge(
                    "group flex items-center justify-center space-x-2 overflow-hidden",
                    reverse ? "-reverse" : "",
                    disabled ? "opacity-80" : "",
                    className
                )}
                onClick={onClick}
                disabled={disabled}
                {...rest}
            >
                {title && <p className={twMerge("text-h5 capitalize", titleClassName)}>{title}</p>}
                {icon}
                {hoverText && (
                    <div className={twMerge("group-hover-text", hoverTextClassName)}>
                        <p className="text-h5">{hoverText}</p>
                    </div>
                )}
                {children}
            </button>
    ) : null;
};

export default FunctionalButton;
